import { createContext } from 'react'

import type { PageLogger } from './createFlowLogger'

export const PageLoggerContext = createContext<PageLogger | null>(null)
